// Norwegian

export default {
  newVersionAvailable: 'Ny versjon tilgjengelig',
  versionInfo: 'En ny versjon av {appName} er tilgjengelig. Vennligst last inn siden på nytt for å oppdatere til versjon {version}.',
  reload: 'Last inn på nytt',
  later: 'Senere',
};
